<p>spinner-modal works!</p>
